import { createContext } from 'react'

export interface User {
  id: string
  email: string
  name: string
  groups?: string[]
  isSuperAdmin?: boolean
}

export interface ImpersonationInfo {
  isImpersonating: boolean
  originalUser?: {
    id: string
    email: string
    name: string
  }
  impersonatedUser?: {
    id: string
    email: string
    name: string
  }
}

export interface AuthContextType {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  impersonation: ImpersonationInfo
  login: () => void
  logout: () => void
  refreshAuth: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
